



























































































































import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import IconHelp from "@/common/components/icons/IconHelp.vue";
import IconLoop from "@/common/components/icons/IconLoop.vue";
import HeaderCategoryNavi from "@/common/components/organisms/header/HeaderCategoryNavi.vue";
import HeaderGroupNavi from "@/common/components/organisms/header/admin/HeaderGroupNavi.vue";
import TheHeaderNaviOfOtherMenu from "@/common/components/organisms/header/general/TheHeaderNaviOfOtherMenu.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

import { postSwitchSite } from "@/general/store/api";
import { SwitchSiteRequest, ToSiteEnum } from "../../../../../gen/authapi/api";
import modalState from "@/common/store/modules/modalState";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    IconBase,
    IconHeart,
    IconHistoryLog,
    IconHelp,
    IconLoop,
    HeaderCategoryNavi,
    HeaderGroupNavi,
    TheHeaderNaviOfOtherMenu
  },
  computed: {
    ...mapState({
      headerInfo: () => commons.headerInfo
    })
  }
})
export default class TheHeaderBottomNaviForPcLayout extends Vue {
  profileNavi = {
    shown: false
  };

  switchButtonSvg = "#ffffff";
  category = {
    iconColor: "#616161",
    textColor: "#616161",
    currentCategoryValue: "all"
  };

  color: string | undefined;

  switchButton: any = {};

  @Prop({
    type: Boolean,
    default: false
  })
  isWideHeader!: boolean;

  @Prop({
    default: () => {
      return [];
    }
  })
  categories!: any;

  currentCategoryObject: any = {
    id: "",
    name: "商品カテゴリー"
  };

  @Prop({ type: Boolean })
  closeHelpPopup!: boolean;

  get colorCode() {
    return commons?.colorCode;
  }
  get shownAllElements() {
    const shownHeaderItem = commons.shownHeaderItem;
    const keyword = "all";
    return shownHeaderItem.includes(keyword);
  }

  get isExists() {
    return (str: any) => {
      const shownHeaderItem = commons.shownHeaderItem;
      const regex = new RegExp(`all|${str}`, "g");
      return shownHeaderItem.some((element: any) => regex.test(element));
    };
  }

  @Watch("closeHelpPopup")
  onCloseHelpPoup() {
    this.profileNavi.shown = false;
    this.$emit("update:close-help-popup", false);
  }

  @Watch("category")
  onCategory(newVal: string, oldVal: string) {
    console.log({
      "TheHeaderBottomNaviForPcLayout.vue": { newVal, oldVal }
    });
  }

  async created() {
    this.color = await commons?.OrgPageSpecific?.page_color;
    this.initSwitchButtonObject();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const categoryParam = urlParams.get("product-category")
      ? parseInt(urlParams.get("product-category") as string)
      : undefined;

    if (categoryParam !== undefined) {
      const catName = this.getLocalCategorByid(categoryParam);
      this.category.currentCategoryValue = catName.id;
      this.currentCategoryObject.id = catName.id;
      this.currentCategoryObject.name = catName.name;
    }
  }

  mouseoverSwitchButton(mouseover = true) {
    const commonPrimary = this.colorCode?.toString();
    const mouseleave = "#ffffff";

    const resultColor: any = {
      mouseover: commonPrimary,
      mouseleave: mouseleave
    };

    const resultIndex: string = mouseover ? "mouseover" : "mouseleave";

    this.switchButtonSvg = resultColor[resultIndex];
  }

  initSwitchButtonObject() {
    const headerInfo = commons.headerInfo;
    const pageType = headerInfo.pageType;
    this.switchButton = headerInfo.switch[pageType];
  }

  get isAdminSite() {
    return false;
  }

  get isUserAdmin() {
    return LocalStorage.getItem("userIsAdmin") === "1" ? true : false;
  }

  async switchSite() {
    let switchSiteRequest: SwitchSiteRequest;
    if (commons.headerInfo.pageType === "general") {
      switchSiteRequest = {
        to_site: ToSiteEnum.Admin
      };
    } else {
      switchSiteRequest = {
        to_site: ToSiteEnum.General
      };
    }

    const response = await postSwitchSite(switchSiteRequest);

    if (commons.headerInfo.pageType !== "general") {
      window.sessionStorage.clear();
      // window.localStorage.clear();
      LocalStorage.removeAll();
    }

    window.location.href = response.redirect_url;
  }

  getLocalCategorByid(id: any) {
    let categories: any = LocalStorage.getItem("categories") as string;
    categories = JSON.parse(categories);

    let ct: any = {};

    const id2 = parseInt(id);

    categories.forEach((item: any) => {
      if (item.id === id2) {
        ct = { id: item.id, name: item.name };
      } else {
        item?.sub_categories?.forEach((ele: any) => {
          if (ele.id === id2) {
            ct = { id: ele.id, name: ele.name };
          }
        });
      }
    });
    return ct;
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  @Watch("closeModalState")
  onCloseModalState() {
    this.profileNavi.shown = false;
  }

  switchShownState() {
    const shown = this.profileNavi.shown;
    this.profileNavi.shown = !shown;
    this.$emit("update:close-help-popup", false);
  }
}
